module.exports = __webpack_public_path__ + "media/images/countryrect/bz-95305e799d6b006b306e0e75d3b6184a.svg";